import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements AfterViewInit {

  @ViewChild('nextButton') nextButton: ElementRef;
  constructor(private elem: ElementRef) { }

  ngAfterViewInit() {
    const el: HTMLElement = this.nextButton.nativeElement as HTMLElement;
    
    setTimeout(() => el.click(), 6000);
  }

  redireccionBannerProcesoIncidentes() {
    window.open('https://comunicaciones.segurossura.com.co/covid19/Contenidos/Documentos/Proceso-de-incidentes.pdf', '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/slider/slider.component.ts